import { getLabelList } from "@/services/settings";
import { getSeatUserList } from "@/services/user";
import { useModel, useRequest } from "@umijs/max";
import { useMemo } from "react";

/** 认证完成后加载共享坐席和标签，保留用户变更后的刷新入口。 */
export default function useGlobalModel() {
  const { initialState } = useModel("@@initialState");
  const ready = Boolean(initialState?.currentUser);
  const { data: seatListData, run: refreshSeatUsers } = useRequest(getSeatUserList, {
    ready,
    refreshDeps: [],
  });
  const seatList = useMemo(
    () =>
      seatListData?.map((item: any) => {
        return {
          label: item.label,
          value: item.value,
          key: item.value,
          extra: item.is_today_seat ? (
            <div className="text-green-500">班</div>
          ) : (
            ""
          ),
        };
      }) || [],
    [seatListData]
  );

  const { data: labelListData, run: getLabels } = useRequest(getLabelList, {
    ready,
    refreshDeps: [],
  });

  // 标签列表
  const labels = useMemo(
    () =>
      labelListData?.map((item: any) => ({
        label: item.name,
        key: item.id,
      })) || [],
    [labelListData]
  );

  return {
    seatList,
    refreshSeatUsers,
    labels,
    refreshLabels: getLabels,
  };
}
